import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, XCircle, Clock, Loader2 } from 'lucide-react';

export function SubscriptionSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simular verificação do pagamento
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);
    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Card className="w-full max-w-md">
          <CardContent className="pt-6 text-center">
            <Loader2 className="h-12 w-12 animate-spin text-blue-600 mx-auto mb-4" />
            <p className="text-gray-600">Verificando pagamento...</p>
          </CardContent>
        </Card>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" data-testid="subscription-success">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <CheckCircle className="h-10 w-10 text-green-600" />
          </div>
          <CardTitle className="text-2xl text-green-600">Pagamento Aprovado!</CardTitle>
          <CardDescription>
            Sua assinatura foi ativada com sucesso.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-green-50 border border-green-200 rounded-lg p-4">
            <p className="text-sm text-green-800">
              Você já pode aproveitar todos os recursos do seu plano. 
              Um email de confirmação foi enviado para você.
            </p>
          </div>
          <Button className="w-full" onClick={() => navigate('/dashboard')}>
            Ir para o Dashboard
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate('/assinatura')}>
            Ver minha assinatura
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export function SubscriptionError() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" data-testid="subscription-error">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <XCircle className="h-10 w-10 text-red-600" />
          </div>
          <CardTitle className="text-2xl text-red-600">Pagamento não aprovado</CardTitle>
          <CardDescription>
            Houve um problema ao processar seu pagamento.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-red-50 border border-red-200 rounded-lg p-4">
            <p className="text-sm text-red-800">
              Verifique os dados do cartão ou tente outro método de pagamento.
              Se o problema persistir, entre em contato com seu banco.
            </p>
          </div>
          <Button className="w-full" onClick={() => navigate('/assinatura')}>
            Tentar novamente
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate('/dashboard')}>
            Voltar ao Dashboard
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}

export function SubscriptionPending() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" data-testid="subscription-pending">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mb-4">
            <Clock className="h-10 w-10 text-yellow-600" />
          </div>
          <CardTitle className="text-2xl text-yellow-600">Pagamento Pendente</CardTitle>
          <CardDescription>
            Estamos aguardando a confirmação do seu pagamento.
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <p className="text-sm text-yellow-800">
              Se você escolheu boleto ou Pix, aguarde a compensação do pagamento.
              Você receberá um email assim que o pagamento for confirmado.
            </p>
          </div>
          <Button className="w-full" onClick={() => navigate('/dashboard')}>
            Ir para o Dashboard
          </Button>
          <Button variant="outline" className="w-full" onClick={() => navigate('/assinatura')}>
            Ver status da assinatura
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
